(function() {
    'use strict';

    angular
        .module('app')
        .directive('autoHeight', autoHeight);

    autoHeight.$inject = ['$window'];
    
    function autoHeight($window) {
        // Usage:
        //     <auto-height></auto-height>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                offSet: "="
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.elem = element;
            var offSet = scope.offSet;
            var offSetPlus = scope.offSet;
            var winHeight = $window.innerHeight;
            var winWidth = $window.innerWidth;

            if (winWidth < 1039) {
                offSetPlus = scope.offSet + 200;
            }

            scope.elem.css('height', winHeight - scope.offSet + 'px');
            //apply size change on window resize
            angular.element($window).bind("resize", function () {
                offSet = scope.offSet;
                var winHeight = $window.innerHeight;
                var winWidth = $window.innerWidth;
                if (winWidth < 768) {
                    offSet = offSet + 150;
                }
                else if (winWidth < 1039) {
                    offSet = offSet + 40;
                }
                scope.elem.css('height', winHeight - offSet + 'px');
            });
            
        }
    }

})();